export namespace NBlogRootPageType {
    export const typeId = 'blog-root';

    export interface ITypeData {
        /**
         * Copy belop page title
         */
        topCopy: string;
        /**
         * If true then tag will redirect location
         * otherwise they will act as a filter without changes
         */
        tagRedirect: string;
    }
}
